//DailyReport
<template>
  <v-scale-transition>
    <wide-panel
      :title="title"
    >
      <v-toolbar flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        />
        <v-spacer />
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="date"
              prepend-icon="mdi-calendar-outline"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="date"
            min="2020-11-01"
            :max="today"
            no-title
            @input="dateMenu = false"
          />
        </v-menu>
      </v-toolbar>
      <v-layout>
        <v-flex xs3>
          <v-subheader>Activations</v-subheader>
        </v-flex>
        <v-flex
          xs3
          offset-xs5
        >
          <v-text-field
            v-model="searchActivation"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-flex>
        <v-flex xs1>
          <v-btn
            dark
            fab
            small
            color="light-green"
            @click="exportReport(activations)"
          >
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="activationHeaders"
        :items="activations"
        :expand="expand"
        :loading="loading"
        :search="searchActivation"
        item-key="location"
        class="elevation-1"
        disable-initial-sort
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-left">
              {{ props.item.location }}
            </td>
            <td
              v-for="plan in dynamicPlans"
              :key="plan"
              class="text-xs-center"
            >
              {{ props.item[plan] || 0 }}
            </td>

            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailActivationHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td
                          v-for="plan in dynamicPlans"
                          :key="plan"
                          class="text-xs-center"
                        >
                          {{ dealerProps.item[plan] || 0 }}
                        </td>

                        <td class="text-xs-center primary">
                          {{ dealerProps.item.total }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Sub-total:
            </td>
            <td
              v-for="plan in dynamicPlans"
              :key="plan"
              class="text-xs-center primary--text"
            >
              {{ totals[plan] }}
            </td>

            <td class="text-xs-center primary">
              {{ totalActivation }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-layout>
        <v-flex xs3>
          <v-subheader>Reloads</v-subheader>
        </v-flex>
        <v-flex
          xs3
          offset-xs5
        >
          <v-text-field
            v-model="searchReload"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-flex>
        <v-flex xs1>
          <v-btn
            dark
            fab
            small
            color="light-green"
            @click="exportReport(reloads)"
          >
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="reloadHeaders"
        :items="reloads"
        :expand="expand"
        :loading="loading"
        :search="searchReload"
        item-key="location"
        class="elevation-1"
        disable-initial-sort
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-left">
              {{ props.item.location }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailReloadHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.reload }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ Number(totalReload).toFixed(2) }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-layout>
        <v-flex xs3>
          <v-subheader>Recruitments</v-subheader>
        </v-flex>
        <v-flex
          xs3
          offset-xs5
        >
          <v-text-field
            v-model="searchRecruitment"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-flex>
        <v-flex xs1>
          <v-btn
            dark
            fab
            small
            color="light-green"
            @click="exportReport(recruitments)"
          >
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="recruitmentHeaders"
        :items="recruitments"
        :expand="expand"
        :loading="loading"
        :search="searchRecruitment"
        item-key="location"
        class="elevation-1"
        disable-initial-sort
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-left">
              {{ props.item.location }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailRecruitmentHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.recruitment }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ totalRecruitment }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-layout>
        <v-flex xs3>
          <v-subheader>Schedule</v-subheader>
        </v-flex>
        <v-flex
          xs3
          offset-xs5
        >
          <v-text-field
            v-model="searchSchedule"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          />
        </v-flex>
        <v-flex xs1>
          <v-btn
            dark
            fab
            small
            color="light-green"
            @click="exportReport(schedules)"
          >
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="scheduleHeaders"
        :items="schedules"
        :expand="expand"
        :loading="loading"
        :search="searchSchedule"
        item-key="location"
        class="elevation-1"
        disable-initial-sort
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-left">
              {{ props.item.location }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailScheduleHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-left">
                          {{ dealerProps.item.msisdn }}
                        </td>
                        <td class="text-xs-left">
                          {{ dealerProps.item.name }}
                        </td>
                        <td class="text-xs-left">
                          {{ dealerProps.item.rank }}
                        </td>
                        <td class="text-xs-center">
                          <v-chip
                            :color="dealerProps.item.workingType === 'Full-time' ? 'success' : 'success darken-3'"
                            text-color="white"
                          >
                            {{ dealerProps.item.workingType }}
                          </v-chip>
                        </td>
                        <td class="text-xs-center">
                          <v-chip
                            :color="dealerProps.item.status === 'Active' ? 'success' : (dealerProps.item.status === 'Demoted' ? 'warning' : 'error')"
                            text-color="white"
                          >
                            {{ dealerProps.item.status }}
                          </v-chip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
      </v-data-table>
    </wide-panel>
  </v-scale-transition>
</template>

<script>
import { DateTime } from 'luxon'
import { createGetParams } from '@/rest'
import * as XLSX from 'xlsx'

const pageTitle = 'X-Force Daily Report'

export default {
  components: {
    WidePanel: () => import(/* webpackChunkName: "widePanel" */ '@/components/WidePanel'),
  },
  data () {
    return {
      title: pageTitle,
      date: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL-dd'),
      today: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL-dd'),
      dateMenu: false,
      loading: false,
      expand: false,
      searchActivation: null,
      activations: [],
      detailActivationHeaders: [],
      dynamicPlans: [],
      totals: {},
      searchReload: null,
      reloads: [],
      searchRecruitment: null,
      recruitments: [],
      searchSchedule: null,
      schedules: [],
      reloadHeaders: [
        {
          text: 'Location',
          align: 'left',
          sortable: true,
          value: 'location',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailReloadHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Reload',
          align: 'center',
          sortable: true,
          value: 'reload',
        },
      ],
      recruitmentHeaders: [
        {
          text: 'Location',
          align: 'left',
          sortable: true,
          value: 'location',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailRecruitmentHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Recruitment',
          align: 'center',
          sortable: true,
          value: 'recruitment',
        },
      ],
      scheduleHeaders: [
        {
          text: 'Location',
          align: 'left',
          sortable: true,
          value: 'location',
        },
        {
          text: 'Checked-in',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      activationHeaders: [],
      detailScheduleHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Msisdn',
          align: 'left',
          sortable: true,
          value: 'msisdn',
        },
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Rank',
          align: 'left',
          sortable: true,
          value: 'rank',
        },
        {
          text: 'Type',
          align: 'center',
          sortable: true,
          value: 'workingType',
        },
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'status',
        },
      ],
      totalActivation: 0,
      totalReload: 0,
      totalRecruitment: 0,
      totalCheckedIn: 0,
    }
  },
  created: function () {
    this.getXForceDailyLocationReport(this.date)
  },
  watch: {
    date: function (date) {
      this.getXForceDailyLocationReport(this.date)
    },
  },
  methods: {
    getXForceDailyLocationReport: async function (date) {
      const params = createGetParams({ date })
      this.loading = true
      this.resetTotals()
      try {
        const response = await this.$rest.get('getXForceDailyLocationReport.php', params)
        const activations = response.data.activations

        if (activations.length > 0) {
          const sample = activations[0]

          this.dynamicPlans = Object.keys(sample).filter(key =>
            !['location', 'items', 'total'].includes(key),
          )
          console.log('dynamicPlans =', this.dynamicPlans)

          this.activationHeaders = [
            {
              text: 'Location',
              align: 'left',
              value: 'location',
            },
            ...this.dynamicPlans.map(plan => ({
              text: plan,
              align: 'center',
              value: plan,
            })),
            {
              text: 'Total',
              align: 'center',
              value: 'total',
            },
          ]

          this.detailActivationHeaders = [
            {
              text: 'Dealer',
              align: 'left',
              value: 'dealer',
            },
            ...this.dynamicPlans.map(plan => ({
              text: plan,
              align: 'center',
              value: plan,
            })),
            {
              text: 'Total',
              align: 'center',
              value: 'total',
            },
          ]
          console.log('activationHeaders =', this.activationHeaders)
        }

        this.totals = {}
        this.totalActivation = 0

        activations.forEach(activation => {
          this.dynamicPlans.forEach(plan => {
            this.totals[plan] =
  Number(this.totals[plan] || 0) +
  Number(activation[plan] || 0)
          })

          this.totalActivation += activation.total
        })

        this.activations = activations
        response.data.reloads.forEach(reload => {
          this.totalReload += reload.total * 1
        })
        response.data.recruitments.forEach(recruitment => {
          this.totalRecruitment += recruitment.total
        })
        response.data.schedules.forEach(schedule => {
          this.totalCheckedIn += schedule.total
        })
        this.activations = response.data.activations
        // this.activations = activations
        this.reloads = response.data.reloads
        this.recruitments = response.data.recruitments
        this.schedules = response.data.schedules
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    resetTotals: function () {
      this.activations = this.reloads = this.recruitments = this.schedules = []
      this.dynamicPlans = []
      this.totals = {}
      this.totalActivation = 0
      this.totalActivation = this.totalReload = this.totalRecruitment = this.totalCheckedIn = 0
    },
    exportReport: function (object) {
      const locationColumn = 0
      const data = []
      const merges = []
      let index = 1

      object.forEach(obj => {
        const merge = {
          s: {
            r: index,
            c: locationColumn,
          },
          e: {
            r: index,
            c: locationColumn,
          },
        }
        let firstRow = true
        obj.items.forEach(item => {
          let row = Array(1)

          if (firstRow) {
            row[0] = obj.location
            firstRow = false
          } else {
            merge.e.r = index
          }
          const itemData = [
            item.dealer,
            ...this.dynamicPlans.map(plan => item[plan] || 0),
            item.total,
          ]

          row = row.concat(itemData)
          data.push(row)
          index++
        })
        merge.e.r > merge.s.r && merges.push(merge)
      })

      let filename
      if (object === this.activations) {
        filename = 'activations'
        data.unshift([
          'Location',
          'Dealer',
          ...this.dynamicPlans,
          'Total',
        ])
      } else if (object === this.reloads) {
        filename = 'reloads'
        data.unshift(['Location', 'Dealer', 'Reload'])
      } else if (object === this.recruitments) {
        filename = 'recruitments'
        data.unshift(['Location', 'Dealer', 'Recruitment'])
      } else {
        filename = 'schedule'
        data.unshift(['Location', 'Dealer', 'Msisdn', 'Name', 'Rank', 'Type', 'Status'])
      }
      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      if (merges.length > 0) {
        ws['!merges'] = merges
      }
      XLSX.utils.book_append_sheet(wb, ws, this.date)
      XLSX.writeFile(wb, 'xforce-' + filename + '-' + this.date + '.xlsx')
    },
  },
}
</script>
